module.exports = __webpack_public_path__ + "static/media/View_Scheduled.715abc28.svg";